<template>
  <div class="navigation-menu-child">
    <div class="content align-top">
      <StoryblokComponent v-for="item in blok" :key="item._uid" :blok="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NavigationMenuWrapperStoryblok } from '~/types/storyblok'
defineProps<{
  blok: NavigationMenuWrapperStoryblok[]
}>()
</script>

<style lang="less">
.navigation-menu-child {
  opacity: 0;
  transition: all 0.3s ease-in-out;
  overflow: hidden;

  @media @wide {
    .absolute();

    z-index: 99;
    width: 100vw;
    top: 100%;
    left: 0;
    padding: 0 @gutter-xl;
    transition: opacity 0.2s ease-in-out 0.1s;
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
  }

  &::before {
    @media @wide {
      .absolute-fill();

      content: '';
      background: fade(@color-fill-normal, 96%);
      backdrop-filter: blur(@4px);
    }
  }

  .content {
    padding: @gutter-xs 0 0 @gutter-xl;

    @media @wide {
      .flex();
      .justify-center();

      padding: @54px 0;
    }
  }

  ul {
    .relative();
    .list-reset();

    padding: 0 0 @gutter-xs;

    @media @wide {
      padding: 0 @gutter-xxl !important;
    }

    &:not(last-child) {
      margin-bottom: @gutter-lg;

      @media @wide {
        margin-bottom: 0;
      }
    }

    li {
      h4 {
        .uppercase();
        .font-sm();
        .font-body();
        .font-medium();
        .space(0.02);

        margin: 0 0 @gutter-sm;

        @media @wide {
          .font-base();
          .space(0.0125);

          padding-bottom: @gutter-xs;
          border-bottom: solid @2px @color-border;
        }
      }

      a {
        .font-body();
        .font-base();
        .block();
        .space(-0.0125);
        .relative();

        padding: @gutter-xxs 0;

        @media @wide {
          .space(0);

          padding: @8px 0;
        }

        > span {
          @media @wide {
            padding: @gutter-xxs @1px;
          }
        }

        &:hover,
        &:focus,
        &.router-link-active {
          span {
            .article-anchor-mixin();

            padding: @gutter-xxs @1px;
            color: darken(@color-text, 15%);
            background-color: tint(@color-primary, 85%);
          }
        }
      }

      .has-children {
        i.icon.icon--opens {
          .hidden();
        }
      }
    }
  }
}
</style>
